import { render, staticRenderFns } from "./OldMatterProgram.vue?vue&type=template&id=0d4239af&scoped=true"
import script from "./OldMatterProgram.vue?vue&type=script&lang=js"
export * from "./OldMatterProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4239af",
  null
  
)

export default component.exports